import React, { useCallback, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  setCancellationStatusFilter,
  setCancellationSearchFilter,
  clearCancellationSearchFilter,
  selectCancellationState,
} from "../../../store/cancellationFilterSlice";

import { CustomDropdown } from "../../../component/customdropdown/CustomDropdown";
import classes from "./cancellationFilterPage.module.css";
import { debounce } from "lodash";
import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";

// IMPORTANT: IDs must be strings (URL params are strings)
const cancellationStatusOptions = [
  { id: "", label: "Select Status" },
  { id: "0", label: "Cancellation Requested" },
  { id: "1", label: "Cancelled" },
  { id: "2", label: "Cancellation Rejected" },
];

export const CancellationFilterPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { status, search } = useSelector(selectCancellationState);
  const dispatch = useDispatch();

  // 🔹 Sync URL → Redux
  useEffect(() => {
    const statusParam = searchParams.get("status") ?? "";
    const searchParam = searchParams.get("search") ?? "";

    dispatch(setCancellationStatusFilter(statusParam));
    dispatch(setCancellationSearchFilter(searchParam));
  }, [searchParams, dispatch]);

  const updateURLAndStore = useCallback(
    (key, value) => {
      const newParams = new URLSearchParams(searchParams);
      if (value) newParams.set(key, value);
      else newParams.delete(key);

      setSearchParams(newParams);

      if (key === "status") dispatch(setCancellationStatusFilter(value));
      if (key === "search")
        dispatch(
          value
            ? setCancellationSearchFilter(value)
            : clearCancellationSearchFilter()
        );
    },
    [dispatch, searchParams, setSearchParams]
  );

 


  return (
    <div className={classes.box}>
      {/* Search input */}
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by Order Id or Transaction Id"
          value={search}
          onSearch={(text) => updateURLAndStore("search", text)}
          onClear={() => updateURLAndStore("search", "")}
        />
      </div>

      {/* Status dropdown */}
      <div className={classes.box__content}>
        <CustomDropdown
          id="status"
          label="Select Status"
          options={cancellationStatusOptions}
          selectedId={status || ""}
          onSelection={(_, value) => updateURLAndStore("status", value)}
        />
      </div>
    </div>
  );
};
